import styles from "../Daetong.module.css"
import { useNavigate } from "react-router-dom";

function FortuneList({ cards, setFortuneList, fortuneList }) {
    const navigate = useNavigate();

    return (
        <div className={`fortuneList ${styles.fortuneList_daetong}`}>
            <ul className="list">
                {
                    cards.map((data, i) => {
                        return (
                            <li
                                key={i}
                                onClick={async () => {
                                    // try {
                                    //     if (
                                    //         window.flutter_inappwebview &&
                                    //         typeof window.flutter_inappwebview.callHandler === "function"
                                    //     ) {
                                    //         // Flutter WebView 환경: 광고 호출
                                    //         await window.flutter_inappwebview.callHandler("showRewardAd");

                                    //         // 광고 시청 완료 후 이동
                                    //         setFortuneList(false);
                                    //         navigate(`/FortuneInfo/${data.ORDER_ID}`);
                                    //     } else {
                                    //         //console.warn("flutter_inappwebview가 없습니다. (브라우저 테스트)");

                                    //         // 브라우저에서 테스트할 때는 바로 이동
                                    //         navigate(`/FortuneInfo/${data.ORDER_ID}`);
                                    //     }
                                    // } catch (e) {
                                    //     console.error("광고 호출 중 에러:", e);
                                    // }
                                    navigate(`/daetong/FortuneInfo/${data.ORDER_ID}`);
                                }}
                            >
                                <div className="fortuneImg">
                                    <img src={process.env.PUBLIC_URL + `${data.FILE_PATH}`} alt={data.TITLE} />
                                </div>
                                <div className="cardContent">
                                    <h4>{data.TITLE}</h4>
                                    <p>{data.CONTENT}</p>
                                </div>
                                <div className="cardIcon">
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            `/image/unsecard/unsecardIllu${data.ORDER_ID}.png`
                                        }
                                        alt=""
                                    />
                                </div>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default FortuneList;
